import React from "react";
import { IconSize, IconProps } from "../theme";

const PenWriting: React.FC<IconProps> = ({ size = IconSize.L }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8862_34224)">
        <path
          d="M21.3113 7.021L17.1216 2.83225C16.9823 2.69293 16.8169 2.58241 16.6349 2.50701C16.4529 2.4316 16.2578 2.39279 16.0608 2.39279C15.8638 2.39279 15.6687 2.4316 15.4867 2.50701C15.3047 2.58241 15.1393 2.69293 15 2.83225L3.43969 14.3926C3.2998 14.5313 3.18889 14.6966 3.11341 14.8786C3.03792 15.0606 2.99938 15.2558 3.00001 15.4529V19.6426C3.00001 20.0404 3.15804 20.4219 3.43935 20.7032C3.72065 20.9845 4.10218 21.1426 4.50001 21.1426H20.25C20.4489 21.1426 20.6397 21.0636 20.7803 20.9229C20.921 20.7822 21 20.5915 21 20.3926C21 20.1937 20.921 20.0029 20.7803 19.8622C20.6397 19.7216 20.4489 19.6426 20.25 19.6426H10.8113L21.3113 9.14257C21.4506 9.00327 21.5611 8.8379 21.6365 8.65589C21.7119 8.47388 21.7507 8.2788 21.7507 8.08178C21.7507 7.88477 21.7119 7.68969 21.6365 7.50768C21.5611 7.32567 21.4506 7.1603 21.3113 7.021ZM18 10.3323L13.8113 6.14257L16.0613 3.89257L20.25 8.08225L18 10.3323Z"
          fill="#071443"
        />
      </g>
      <defs>
        <clipPath id="clip0_8862_34224">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PenWriting;
